// Values set in the Google Sheet script
enum GradeLevel {
  Primary = 'Primary (Grades K - 2)',
  Intermediate = 'Intermediate (Grades 3 - 5)',
  Middle = 'Middle School (Grades 6 - 8)',
  High = 'High School (Grades 9 - 12)',
}

export default GradeLevel;
